export type IScreenRect = Partial<DOMRect>;
export interface IScreenMouse {
  movementX: number;
  movementY: number;
  clientX: number;
  clientY: number;
  button?: string;
  wheelDelta?: string | undefined;
}
export interface IScreenKeyboard {
  keyCode: number;
}

export const CTRLTYPE = {
  MouseMotion: "MouseMotion",
  MousePress: "MousePress",
  MouseRelease: "MouseRelease",
  MouseWheel: "MouseWheel",
  KeyPress: "KeyPress",
  KeyRelease: "KeyRelease",
};

let WindoewScreen: DOMRect | null = null;

export class ScreenMouseMotion {
  x: number;
  y: number;
  z: number;
  width?: number;
  height?: number;
  type?: string;
  flag?: boolean;
  button?: number;
  constructor(target: IScreenRect, e: IScreenMouse, flag = false) {
    if (e) {
      this.type = CTRLTYPE.MouseMotion;
      this.flag = flag;
      this.x = !flag ? e.movementX : e.clientX;
      this.y = !flag ? e.movementY : e.clientY;
      this.z = 0;
      this.width = target.width;
      this.height = target.height;
    } else {
      this.x = this.y = this.z = this.button = 0;
    }
  }
}

export class ScreenMousePress {
  x?: number;
  y?: number;
  button?: string;
  type: string;
  constructor(target: IScreenRect, e: IScreenMouse, flag = false) {
    if (e) {
      this.x = !flag ? e.movementX : e.clientX;
      this.y = !flag ? e.movementY : e.clientY;
      this.button = e.button;
    }
    this.type = CTRLTYPE.MousePress;
  }
}

export class ScreenMouseRelease {
  x?: number;
  y?: number;
  button?: string;
  type: string;
  constructor(target: IScreenRect, e: IScreenMouse, flag = false) {
    if (e) {
      this.x = !flag ? e.movementX : e.clientX;
      this.y = !flag ? e.movementY : e.clientY;
      this.button = e.button;
    }
    this.type = CTRLTYPE.MouseRelease;
  }
}

export class ScreenMouseWheel {
  fb?: string;
  type: string;
  constructor(e: IScreenMouse) {
    if (e) {
      this.fb = e.wheelDelta;
    }
    this.type = CTRLTYPE.MouseWheel;
  }
}

export class ScreenKeyPress {
  type: string;
  keyCode?: number;
  lock?: number;
  constructor(target: IScreenRect, e: IScreenKeyboard, lock: number) {
    if (e) {
      this.keyCode = e.keyCode;
      this.lock = lock;
    }
    this.type = CTRLTYPE.KeyPress;
  }
}
export class ScreenKeyRelease {
  type: string;
  keyCode?: number;
  lock?: number;
  constructor(target: IScreenRect, e: IScreenKeyboard, lock: number) {
    if (e) {
      this.keyCode = e.keyCode;
      this.lock = lock;
    }
    this.type = CTRLTYPE.KeyRelease;
  }
}

export function ScreenKeyFliter(e: KeyboardEvent) {
  return e.keyCode === 91;
}

export function ScreenInit(target: DOMRect | null) {
  WindoewScreen = target;
}

export function ScreenValue() {
  return WindoewScreen
    ? {
        width: WindoewScreen.width,
        height: WindoewScreen.height,
      }
    : null;
}
